import Header from "../Component/UserEnd/Header";
import BlogCards from "../Component/UserEnd/BlogCard";
import Footer from "../Component/UserEnd/Footer";

function BlogPage() {
    return (
        <>
            <Header />
            <BlogCards/>
            <Footer />
        </>
    );
}

export default BlogPage;
